const WIDTH = 100;
const HEIGHT = 12;

const BG = {
    TINT: 0x2c3e50,
};

const BAR = {
    TINT: {
        CHARGING: 0x1abc9c,
        WORKING: 0xf1c40f,
    },
};

export default class Progress extends Phaser.GameObjects.Container {
    private tweenWorking: Phaser.Tweens.Tween | null;
    private tweenCharging: Phaser.Tweens.Tween | null;

    private bg!: Phaser.GameObjects.Image;
    private bar!: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);

        this.tweenWorking = null;
        this.tweenCharging = null;

        this.setupBG();
        this.setupBar();
    }

    setupBG() {
        this.bg = this.scene.add.image(0, 0, 'atlas', 'blank');
        this.bg.setDisplaySize(WIDTH, HEIGHT);
        this.bg.setTint(BG.TINT);
        this.add(this.bg);
    }

    setupBar() {
        let x = -WIDTH / 2;
        let y = 0;

        this.bar = this.scene.add.image(x, y, 'atlas', 'blank');
        this.bar.setDisplaySize(WIDTH, HEIGHT);
        this.bar.setOrigin(0, 0.5);
        this.bar.setTint(BAR.TINT.CHARGING);
        this.add(this.bar);
    }

    setReady() {
        this.tweenCharging?.stop();

        this.bar.displayWidth = WIDTH;
        this.bar.setTint(BAR.TINT.WORKING);
    }

    startWorking(time: number) {
        let duration = time * 1000;

        this.tweenWorking = this.scene.tweens.addCounter({
            duration,
            from: 1,
            to: 0,
            onUpdate: (tween) => {
                let width = WIDTH * tween.getValue();
                this.bar.displayWidth = width;
            },
        });
    }

    startCharging(time: number) {
        let duration = time * 1000;
        this.bar.setTint(BAR.TINT.CHARGING);

        this.tweenCharging = this.scene.tweens.addCounter({
            duration,
            from: 0,
            to: 1,
            onUpdate: (tween) => {
                let width = WIDTH * tween.getValue();
                this.bar.displayWidth = width;
            },
        });
    }
}
